import React from 'react';
import StraigthenIcon from '@mui/icons-material/Straighten';

export const RulerIcon = props => (
  <StraigthenIcon style={{transform: 'rotate(-45deg)'}} {...props} />
);
